import React, { useCallback, useRef, useState } from 'react'
import './styles.css'
import { Button } from 'primereact/button'
import { PersonApi } from '../../api'
import { InputText } from 'primereact/inputtext'
import { Loading } from '../loading/Loading'
import { authState } from '../../state/Auth.state'

const NULL_DATE = new Date('1800-01-01')

const parseDate = (dd: string, mm: string, yyyy: string): Date => {
    const day = Number(dd), month = Number(mm), year = Number(yyyy)
    if (!day || !month || !year || yyyy.length < 4) return NULL_DATE
    const date = new Date(year, month - 1, day)
    date.setFullYear(year)
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return NULL_DATE
    return date
}

export const ForgotPassword = () => {
    const [loading, setLoading] = useState(false)
    const [done, setDone] = useState(false)
    const [firstName, setFirstName] = useState('')
    const [bdDay, setBdDay] = useState('')
    const [bdMonth, setBdMonth] = useState('')
    const [bdYear, setBdYear] = useState('')
    const refMonth = useRef<HTMLInputElement>(null)
    const refYear = useRef<HTMLInputElement>(null)

    const birthday = parseDate(bdDay, bdMonth, bdYear)
    const formValid = firstName.trim().length > 0 && birthday > NULL_DATE

    const handleSubmit = useCallback(() => {
        setLoading(true)
        new PersonApi(authState.apicfg())
            .apiPersonIgvRequestGet({ vorname: firstName.trim(), gebDat: birthday })
            .catch(() => {})
            .finally(() => {
                setLoading(false)
                setDone(true)
            })
    }, [firstName, birthday])

    return (
        <>
            <Loading loading={loading} />
            <div className='register-container'>
                <div className='register-form card'>
                    <h2 style={{ marginBottom: '1rem' }}>Zugangsdaten vergessen?</h2>
                    {done ? (
                        <p style={{ marginBottom: '1rem' }}>
                            Wir haben Ihre Anforderung entgegengenommen und die Zugangsdaten an die hinterlegte E-Mail-Adresse verschickt.
                        </p>
                    ) : (
                        <form
                            onSubmit={(e) => { e.preventDefault(); if (formValid) handleSubmit() }}
                            style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}
                        >
                            <InputText
                                placeholder='Vorname *'
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value ?? '')}
                            />
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                                <InputText
                                    style={{ width: '3.5rem', textAlign: 'center' }}
                                    placeholder='TT'
                                    maxLength={2}
                                    value={bdDay}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, '').slice(0, 2)
                                        setBdDay(val)
                                        if (val.length === 2) refMonth.current?.focus()
                                    }}
                                />
                                <span style={{ color: '#888' }}>.</span>
                                <InputText
                                    style={{ width: '3.5rem', textAlign: 'center' }}
                                    placeholder='MM'
                                    maxLength={2}
                                    value={bdMonth}
                                    ref={refMonth}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, '').slice(0, 2)
                                        setBdMonth(val)
                                        if (val.length === 2) refYear.current?.focus()
                                    }}
                                />
                                <span style={{ color: '#888' }}>.</span>
                                <InputText
                                    style={{ width: '5rem', textAlign: 'center' }}
                                    placeholder='JJJJ'
                                    maxLength={4}
                                    value={bdYear}
                                    ref={refYear}
                                    onChange={(e) => {
                                        const val = e.target.value.replace(/\D/g, '').slice(0, 4)
                                        setBdYear(val)
                                    }}
                                />
                                <span style={{ color: '#aaa', fontSize: '0.85rem', whiteSpace: 'nowrap' }}>Geburtsdatum</span>
                            </div>
                            <Button style={{ marginTop: '0.5rem' }} disabled={!formValid} type='submit'>
                                Zugangsdaten anfordern
                            </Button>
                        </form>
                    )}
                    <Button outlined onClick={() => (window.location.hash = '#/home')}>
                        Zur&#252;ck zum Login
                    </Button>
                </div>
            </div>
        </>
    )
}
